<template>
    <div
        class="relative flex items-center gap-4 rounded border border-gray-800 accent-primary transition-all"
        :class="{
            'cursor-not-allowed opacity-50': productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity),
            'cursor-pointer': !productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)
        }">
        <div class="flex w-full">
            <FormKit type="group" :name="id">
                <FormKit
                    v-model="productForm().currentProductWithSelectedExtras.extras[extraId].items[id].selected"
                    type="checkbox"
                    :legend="title"
                    name="selected"
                    :disabled="productForm().extraItemIsDisabled(extraId, id, maximumSelectionQuantity)"
                    @click="productForm().extraItemCheckedLogic(extraId, id, maximumSelectionQuantity)">
                    <template #label>
                        <div class="flex w-full shrink items-center justify-between gap-2">
                            <span class="select-none text-base font-bold text-gray-700 lg:group-hover:text-primary">
                                {{ title }}
                            </span>
                            <div
                                v-if="showPrices && price || props.description || props.allergies"
                                class="flex items-center"
                            >
                                <span v-if="showPrices && price" class="select-none text-sm font-bold text-gray-700 lg:group-hover:text-primary">
                                    {{ currencyFormat(price) }}
                                </span>
                                <Icon
                                    v-if="props.description || props.allergies"
                                    class="ml-3 text-2xl text-black" :icon="IconInfo" :auto-align="false"
                                    @click="productForm().setExtraDetailsInfo(props)"
                                />
                            </div>
                        </div>
                    </template>
                </FormKit>
                <slot />
            </FormKit>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ItemProps } from '~/types/local-types'
    import IconInfo from '@/assets/icons/info.svg'
    import Icon from '~/components/Icon.vue'
    import { productForm } from '~/store/productForm'
    // TODO: Make the entire extrasItem clickable
    import { currencyFormat } from '~/utils/currency-utils'
    const props = defineProps<ItemProps>()
</script>
